import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sv2-step" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Create your account", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-step__subtitle" }, "Secure your account to access the Ditto portal.", -1)
const _hoisted_4 = { class: "sv2-fields" }
const _hoisted_5 = { class: "sv2-field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "sv2-field__label" }, [
  /*#__PURE__*/_createTextVNode("Password"),
  /*#__PURE__*/_createElementVNode("span", { class: "sv2-field__required" }, "*")
], -1)
const _hoisted_7 = { class: "sv2-input-wrap" }
const _hoisted_8 = { class: "sv2-input-wrap__icon" }
const _hoisted_9 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_10 = {
  key: 1,
  class: "sv2-field__hint"
}
const _hoisted_11 = { class: "sv2-field" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "sv2-field__label" }, [
  /*#__PURE__*/_createTextVNode(" Confirm Password"),
  /*#__PURE__*/_createElementVNode("span", { class: "sv2-field__required" }, "*")
], -1)
const _hoisted_13 = { class: "sv2-input-wrap" }
const _hoisted_14 = { class: "sv2-input-wrap__icon" }
const _hoisted_15 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_16 = {
  class: "sv2-check",
  style: {"margin-top":"8px"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "sv2-check__text" }, [
  /*#__PURE__*/_createTextVNode(" I agree to the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.airsquirrels.com/ditto/terms",
    target: "_blank",
    rel: "noopener noreferrer"
  }, " Terms and Conditions "),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.airsquirrels.com/privacy-policy/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, " Privacy Policy ")
], -1)
const _hoisted_18 = {
  key: 0,
  class: "sv2-form-error"
}
const _hoisted_19 = { class: "sv2-form-error__body" }
const _hoisted_20 = { class: "sv2-actions" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "sv2-spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ph_lock = _resolveComponent("ph-lock")!
  const _component_ph_arrow_left = _resolveComponent("ph-arrow-left")!
  const _component_ph_arrow_right = _resolveComponent("ph-arrow-right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _createVNode(_component_ph_lock, {
              size: 16,
              weight: "fill"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.password) = $event)),
            type: "password",
            class: _normalizeClass(["sv2-input sv2-input--icon", { 'sv2-input--error': !!_ctx.passwordMessage }]),
            placeholder: "Create a password"
          }, null, 2), [
            [_vModelText, _ctx.form.password]
          ])
        ]),
        (_ctx.passwordMessage)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.passwordMessage), 1))
          : (_openBlock(), _createElementBlock("p", _hoisted_10, " At least " + _toDisplayString(_ctx.passwordMinLength) + " characters, with an upper case letter, a lower case letter and a number. ", 1))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, [
            _createVNode(_component_ph_lock, {
              size: 16,
              weight: "fill"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.confirmPassword) = $event)),
            type: "password",
            class: _normalizeClass(["sv2-input sv2-input--icon", { 'sv2-input--error': _ctx.showErrors && !!_ctx.confirmError }]),
            placeholder: "Confirm your password"
          }, null, 2), [
            [_vModelText, _ctx.form.confirmPassword]
          ])
        ]),
        (_ctx.showErrors && _ctx.confirmError)
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.confirmError), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("label", _hoisted_16, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.agreedToTerms) = $event)),
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.form.agreedToTerms]
        ]),
        _hoisted_17
      ])
    ]),
    (_ctx.stepError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.stepError), 1),
          (_ctx.serverErrorField === 'email')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "sv2-btn-subtle",
                type: "button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('edit-email')))
              }, " Change email address "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("button", {
        class: "sv2-btn-back",
        type: "button",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('back')))
      }, [
        _createVNode(_component_ph_arrow_left, {
          size: 14,
          weight: "bold"
        }),
        _createTextVNode(" Back ")
      ]),
      _createElementVNode("button", {
        class: "sv2-btn-primary",
        type: "button",
        disabled: !_ctx.form.agreedToTerms || _ctx.submitting,
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleNext && _ctx.handleNext(...args)))
      }, [
        (_ctx.submitting)
          ? (_openBlock(), _createElementBlock("span", _hoisted_22))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.submitting ? 'Creating…' : 'Create Account') + " ", 1),
        (!_ctx.submitting)
          ? (_openBlock(), _createBlock(_component_ph_arrow_right, {
              key: 1,
              size: 16,
              weight: "bold"
            }))
          : _createCommentVNode("", true)
      ], 8, _hoisted_21)
    ])
  ]))
}